"use strict";

// TODO: maybe to local storage?
window.userKeywords = {};
const {
  keywordId,
  keywordSlug,
  keywordName
} = document.currentScript.dataset;
const tagsInfo = document.querySelector('.tags__info_wrap');
const followBtn = document.querySelector('.tags__info_btn');
const unfollowBtn = document.querySelector('.tags__dropdown_item');
const dropdownMenu = document.querySelector('.dropdown-menu');
const toggleFollowMode = (isFollowing = true) => {
  const notFollowingEls = tagsInfo.querySelectorAll('.not_following');
  const followingEls = tagsInfo.querySelectorAll('.following');
  if (isFollowing) {
    followingEls.forEach(el => {
      el.classList.remove('hidden');
    });
    notFollowingEls.forEach(el => {
      el.classList.add('hidden');
    });
  } else {
    followingEls.forEach(el => {
      el.classList.add('hidden');
    });
    notFollowingEls.forEach(el => {
      el.classList.remove('hidden');
    });
  }
};

// eslint-disable-next-line no-unused-vars
const toggleDropdown = () => {
  dropdownMenu.classList.toggle('hidden');
};
const getUserKeywords = async (currentPage = 1) => {
  const userToken = window.getUserToken();
  const apiUrl = `${window.baseApiUrl}/users/me/keywords?page=${currentPage}`;
  const headers = window.baseHeadersJsonApi;
  headers.Authorization = `Bearer ${userToken}`;
  try {
    const response = await fetch(apiUrl, {
      headers
    });
    if (response.status !== 200) {
      console.warn('[Keywords] Something went wrong with getting of user keywords, check dedicated response.');
    } else if (response.status === 200) {
      const responseData = await response.json();
      const responseDataDeserilazed = window.kitsuCore.deserialise(responseData);
      window.userKeywords = window.userKeywords || {};
      responseDataDeserilazed.data.forEach(keywordData => {
        keywordData.page = currentPage;
        window.userKeywords[keywordData.slug] = keywordData;
      });
      return responseDataDeserilazed;
    }
  } catch (error) {
    console.error('[Keywords] Error while getting user keywords:', error);
  }
};
document.addEventListener('DOMContentLoaded', async () => {
  const userToken = window.getUserToken();
  let currentPage = 1;
  let totalPages = 1;
  if (userToken) {
    const firstUserKeywordsPage = await getUserKeywords();
    totalPages = firstUserKeywordsPage.meta.pagination.pages;
    if (totalPages > currentPage) {
      currentPage += 1;
      for (currentPage; currentPage <= totalPages; currentPage++) {
        // eslint-disable-next-line no-await-in-loop
        await getUserKeywords(currentPage);
      }
    }
    if (window.userKeywords[keywordSlug]) {
      toggleFollowMode(true);
    } else {
      toggleFollowMode(false);
    }
  } else {
    toggleFollowMode(false);
  }
});
followBtn.addEventListener('click', async () => {
  const userToken = window.getUserToken();
  if (userToken) {
    const profileData = window.getProfileData();
    const apiUrl = `${window.baseApiUrl}/users/${profileData.id}/keywords`;
    const headers = window.baseHeadersJsonApi;

    // We do not wait for request to finish
    toggleFollowMode();
    headers.Authorization = `Bearer ${userToken}`;
    const keywordData = {
      id: keywordId,
      type: 'keyword',
      attributes: {
        name: keywordName,
        slug: keywordSlug
      }
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          data: keywordData
        })
      });
      if (response.status !== 201) {
        console.warn('[Keywords] Something went wrong with post of user keyword, check dedicated response.');
        toggleFollowMode(false);
      } else if (response.status === 201 || response.status === 200) {
        window.userKeywords[keywordSlug] = keywordData;
      }
    } catch (error) {
      console.error('[Keywords] Error while creating user keyword:', error);
      toggleFollowMode(false);
    }
  } else {
    window.openModalWelcome('keywords');
  }
});
unfollowBtn.addEventListener('click', async () => {
  const userToken = window.getUserToken();
  if (userToken) {
    const profileData = window.getProfileData();
    const apiUrl = `${window.baseApiUrl}/users/${profileData.id}/keywords/${keywordId}`;
    const headers = window.baseHeadersJsonApi;

    // We do not wait for request to finish
    toggleFollowMode(false);
    headers.Authorization = `Bearer ${userToken}`;
    try {
      const response = await fetch(apiUrl, {
        method: 'DELETE',
        headers
      });
      if (response.status !== 204) {
        console.warn('[Keywords] Something went wrong with delete of user keyword, check dedicated response.');
        toggleFollowMode();
      } else {
        delete window.userKeywords[keywordSlug];
      }
    } catch (error) {
      console.error('[Keywords] Error while deleting user keyword:', error);
      toggleFollowMode();
    }
  }
});